const en = {
    common: {
        error: "Error",
        warning: "Warning!",
        success: "Success",
        back: "Back",
        cancel: "Cancel",
        accept: "Accept",
    },

    login: {
        title: "Login",
        username: "Username",
        password: "Password",
        login: "Login",
        changePassword: "Change Password",
        currentPassword: "Current Password",
        newPassword: "New Password",
        sessionExpired: "Session Expired",
        yourSessionHasExpired: "Your session has expired",
        serviceUnderMaintenance: "Service under maintenance",
        errorLogging: "Error signing in",
        accept: "Accept",
    },

    navigation: {
        home: "Home",
        payments: "Payments",
        certificates: "Certificates",
        accountStatus: "Account Status",
    },

    pages: {
        login: "Login",
        home: "Home",
        payments: "Payments",
        certificates: "Certificates",
        accountStatus: "Account Status",
        notFound: "Page Not Found",
    },

    validation: {
        requiredUsername: "You must enter your username!",
        requiredCurrentPassword:
            "You must enter your current password!",
        requiredNewPassword:
            "You must enter your new password!",
        minimumPassword:
            "It must contain at least 6 characters!",
        requiredCompany:
            "You must select a company to login!",
    },

    sideBar: {
        user: "USER",
        portal: "SUPPLIER",
        supplier: "PORTAL",
        init: "Home",
        Payments: "Payments",
        Certificates: "Certificates",
        statementOfAccount: "Statement of account",
        LogOut: "Log Out",
    },

    certificates: {
        certificateGeneration: "Certificate Generation",
        certificates: "certificates",
        generateCertificate: "Generate Certificate",
        loadingTable: "Loading table",
        generatingCertificate: "Generating Certificate",
        RF: "RF: Income Tax Withholding",
        RC: "RC: Industry and Commerce Withholding Tax",
        RV: "RV: VAT Withholding",
        SB: "SB: Firefighter Surcharge",
        CR: "CR: CREE Withholding Tax",
        SelectionParameters: "Selection Parameters",
        certificateType: "Certificate Type",
        startPeriod: "Start Period",
        endPeriod: "End Period",
        sessionExpired: "Session Expired",
        yourSessionHasExpired: "Your session has expired",
    },

    localizator: {
        NoRecordsFound: "No records found!",
        exportRecords: "Export Records",
        search: "search",
        hello: "Hello",
        records: "Records",
        delete: "Delete",
        add: "Add",
        edit: "Edit",
        deleteTheRecord: "Do you want to delete the record?",
        save: "Save",
        cancel: "Cancel",
        groupedby: "Grouped by:",
        dragToGroup: "Drag a column here to group",
        noAssociatedDocument: "No withholdings are associated with this document",
    },

    login_init: {
        welcome: "Welcome",
        username: "Username",
        password: "Password",
        society: "Company",
        societies: "Companies",
        noSocietiesFound: "No Companies Found",
        login: "Login",
        rememberPassword: "Remember Password",
        changePassword: "Change Password",
        viewinstructions: "View instructions",
        viewdetailedsupplierinstructions: "View detailed supplier instructions",
        viewdetailedinvestorguide: "View detailed investor guide"
    },

    accountState: {
        supplier: "Supplier",
        invoice: "Invoice",
        invoiceDate: "Invoice Date",
        paymentDate: "Payment Date",
        grossAmount: "Gross Amount",
        netAmount: "Net Amount",
        currency: "currency",
        documentText: "Document text",
        sessionExpired: "Session Expired",
        yourSessionHasExpired: "Your session has expired",
        functionalityBlocked: "Functionality blocked",
        accountStatement: "Account statement - Outstanding invoices",
        listOfOutstandinInvoices: "List of outstanding invoices: Selection parameters",
        cutOffDate: "Cut-off Date:",
        invoice: "Invoice:",
        enterInvoice: "Enter invoice number",
        search: "search",
        OutstandingInvoicesSummary: "Outstanding Invoices Summary",
        loadingTable: "Loading table",
        generateExcelFile: "Generate Excel File",
        arrivedUndefined: "The data for querying open items arrived undefined",
    },

    accountDetail: {
        documentType: "Document Type",
        documentDescription: "Document Description",
        amount: "Amount",
        currency: "Currency",
        documentDetails: "Document Details",
        loadingTable: "Loading Table",
    },

    home: {
        summary: "Summary",
    },

    detailedAccordion: {
        paymentDate: "Payment Date",
        paymentDocument: "Payment Document",
        totalAmount: "Total Amount",
        currency: "Currency",
        amount: "Amount",
        date: "Date",
        invoice: "Invoice",
        invoiceDescription: "Invoice Description",
        supplierData: "Supplier Data",
        messageSupplier: "Dear supplier, if your information is outdated, please send a copy of your tax ID to the email address provided.",
        tokenExpired: "The token expired or the backend closed and the cookies were reset or deleted",
        sessionExpired: "Session Expired",
        yourSessionHasExpired: "Your session has expired",
        paymentList: "Payment list: Selection parameters",
        arrivedUndefined: "The data for querying open items arrived undefined",
        dataPayments: "The data for inquiring about payments",
        loadingTable: "Loading table",
        totalAmountList: "Total amount of the payment list:",
        outstandingInvoices: "Outstanding Invoices",
        totalAmountInvoices: "Total amount of outstanding invoices:",
    },

    cardProfile: {
        companyAddress: "Company Address:",
        city: "City:",
        phone: "Phone:",
        mobilePhone: "Mobile phone:",
        email: "E-mail:",
        society: "Society:",
        creditor: "Creditor:",
        taxIdentificationNumber: "Tax Identification Number 1:",
        creditorName: "Creditor Name:",
        companyName: "Company name:",
    },

    payments: {
        payments: "Payments",
        paymentList: "Payment list: Selection parameters",
        search: "search",
        generateExcelFile: "Generate Excel File",
        paymentsummary: "Payment Summary",
        loadingTable: "Loading table",
        paymentDetails: "Payment details",
        supplier: "Supplier",
        paymentDocument: "Payment document",
        date: "Date",
        amountPaidInML: "Amount paid in ML",
        currency: "Currency",
        arrivedUndefined: "The payment query data arrived undefined",
        sessionExpired: "Session Expired",
        yourSessionHasExpired: "Your session has expired",
        consultaPagosService: "The consultaPagos service is not responding.",
        functionalityBlocked: "Functionality blocked",
    },

    paymentsDetail: {
        supplier: "Supplier",
        documentType: "Doc. Type",
        documentDescription: "Doc. description",
        invoice: "Invoice",
        invoiceDate: "Invoice date",
        grossValue: "Gross value",
        vatValue: "VAT value",
        withholdingAmount: "Withholding Amount",
        withholdingTaxBase: "Withholding Tax Base",
        percenWithholding: "% Withholding",
        netValue: "Net value",
        currency: "Currency",
        arrivedUndefined: "The payment query data arrived undefined",
        sessionExpired: "Session Expired",
        yourSessionHasExpired: "Your session has expired",
        generateCertificatesService: "GenerateCertificates service is not responding",
    },

    datePicker: {
        date: "Date",
        initial: "Initial",
        end: "End",
        dateInitEnd: "The initial date must be earlier than the end date.",
        searchIniEnd: "You must enter the start and end dates to search.",
    },
};

export default en;